/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://apiv2.owler.com';
}

/**
 * Parameters for `OwlerApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
